<section class="main-section">
  <form>
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box">
          <div class="text-center">
            <h2 class="text-black mb-3 review">Payment Conformation</h2>
          </div>
          <div class="row">
            <div class="col">
              <div class="row mt-4">
                <div class="col-6">
                  <label class="text-black"><b>Invoice Number : </b>{{pay.invoiceNum}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Invoice Date : </b>{{pay.invoiceDate}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Invoice Amount : </b>{{pay.totalAmount}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>External Reference Number : </b>{{pay.paymentRefNumber}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Notes : </b>{{pay.comments}}</label>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Payment Mode : </b>{{(pay.paymentType == 'BANK_TRANSFER' ? 'Bank Transfer' :
                    (pay.paymentType == 'CHEQUE' ? 'Cheque' :
                      (pay.paymentType == 'CASH' ? 'Cash' : "")))}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Payment Reference Number : </b>{{pay.refNumber}}</label><br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-right mt-3">
      <div class="col">
        <button *ngIf="user.role === 'ACCOUNT_OWNER'" type="button" routerLink="/admin/invoices" class="btn btn-cancel">Close</button>
        <button *ngIf="user.role === 'ROLE_ADMIN'" type="button" routerLink="/admin/adminInvoice" class="btn btn-cancel">Close</button>
      </div>
    </div>
  </form>
</section>
